"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.findUserSession = exports.UMU_GRAPHQL_BASE_URL = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _createAppolloClient = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/createAppolloClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  query findUserSession($type1: String) {\n    findUserSession(identifierKey: $type1) {\n      jwtToken\n    }\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  query getUserDepartmentsByApp($type1: String, $type2: String) {\n    getUserDepartmentsByApp(userId: $type1, appName: $type2) {\n      departmentId\n    }\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  mutation removeUserPersona($type1: String, $type2: String) {\n    removeUserPersona(userId: $type1, personaName: $type2) {\n      message\n      statusCode\n    }\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  mutation saveUserPersona($type: UserPersona) {\n    saveUserPersona(request: $type) {\n      message\n      userId\n      statusCode\n    }\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  query getUserDepartments($type1: String) {\n    getUserDepartments(userId: $type1) {\n      departmentId\n    }\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  query findUsersByPersonaName($type1: String) {\n    findUsersByPersonaName(personaName: $type1)\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  mutation saveUserMaster($type1: UserMaster) {\n    saveUserMaster(request: $type1) {\n      userId\n      message\n      statusCode\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  query getUsersByAppandDept($type1: String, $type2: String) {\n    getUsersByAppandDept(application: $type1, deptId: $type2) {\n      userId\n      name\n      userNumber\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  query findByUserId($type1: String) {\n    findByUserId(userId: $type1) {\n      userId\n      createDT\n      emailId\n      firstName\n      lastName\n      phoneNo\n      title\n      country\n      userType\n      userNumber\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  query getProfileImage($type1: String!) {\n    getProfileImage(userId: $type1) {\n      userId\n      firstName\n      lastName\n      profileImage\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  query getUserBrands($type1: String!) {\n    getUserBrands(userId: $type1) {\n      brandCode\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  query getUser($type1: String!) {\n    getUser(userId: $type1) {\n      userId\n      firstName\n      lastName\n      Dept\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query findByUserApps($type1: String) {\n    findByUserApps(userId: $type1) {\n      userId\n      jwtToken\n      appNames\n      jwtCacheKey\n      status\n      brands\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query findByUserAppAndFunctions($type1: String, $type2: String) {\n    findByUserAppAndFunctions(userId: $type1, appName: $type2) {\n      userId\n      jwtToken\n      appName\n      appRoles\n      appFns\n      rdsPerId\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UMU_GRAPHQL_BASE_URL = process.env.NODE_ENV === "production" ? "/apollo_gateway/graphql" : (window.localStorage.getItem("devDomain") || "https://cornerstone-dev.elcompanies.net") + "/apollo_gateway/graphql";
exports.UMU_GRAPHQL_BASE_URL = UMU_GRAPHQL_BASE_URL;
var fetchUserdetails = (0, _graphqlTag.default)(_templateObject());
var fetchUserApps = (0, _graphqlTag.default)(_templateObject2());
var GET_USER_DEPARTMENTS = (0, _graphqlTag.default)(_templateObject3());
var GET_USER_BRANDS = (0, _graphqlTag.default)(_templateObject4()); // roles {
//        appName
//        appFns
//      }

var GET_PROFILE_IMAGE = (0, _graphqlTag.default)(_templateObject5());
var FETCH_USER_NAME = (0, _graphqlTag.default)(_templateObject6());
var GET_BY_USER_APPDEPT = (0, _graphqlTag.default)(_templateObject7());
var SAVE_USER_MASTER = (0, _graphqlTag.default)(_templateObject8());
var FETCH_USERS = (0, _graphqlTag.default)(_templateObject9());
var FETCH_USER_DEPARTMENTS = (0, _graphqlTag.default)(_templateObject10());
var ADD_USER = (0, _graphqlTag.default)(_templateObject11());
var REMOVE_USER = (0, _graphqlTag.default)(_templateObject12());
var GET_USER_DEPARTMENTS_BY_APP = (0, _graphqlTag.default)(_templateObject13());
var client = (0, _createAppolloClient.default)(UMU_GRAPHQL_BASE_URL, {
  appName: "UMU"
});
var FETCH_SESSION = (0, _graphqlTag.default)(_templateObject14());

var findUserSession = function findUserSession(_ref) {
  var identifierKey = _ref.identifierKey;
  return client.query({
    query: FETCH_SESSION,
    fetchPolicy: "network-only",
    variables: {
      type1: identifierKey
    }
  }).then(function (_ref2) {
    var data = _ref2.data;
    return data.findUserSession;
  });
};

exports.findUserSession = findUserSession;

var EntitlementService = /*#__PURE__*/function () {
  function EntitlementService() {
    _classCallCheck(this, EntitlementService);
  }

  _createClass(EntitlementService, null, [{
    key: "fetch_user_details",
    value: function fetch_user_details(userId, appName) {
      return client.query({
        query: fetchUserdetails,
        variables: {
          type1: userId,
          type2: appName
        }
      });
    }
  }, {
    key: "getUserDepartments",
    value: function getUserDepartments(userId) {
      return client.query({
        query: FETCH_USER_DEPARTMENTS,
        variables: {
          type1: userId
        }
      });
    }
  }, {
    key: "getUserBrands",
    value: function getUserBrands(userId) {
      return client.query({
        query: GET_USER_BRANDS,
        variables: {
          type1: userId
        }
      });
    }
  }, {
    key: "fetch_user_apps",
    value: function fetch_user_apps(userId) {
      return client.query({
        query: fetchUserApps,
        variables: {
          type1: userId
        },
        fetchPolicy: "no-cache"
      });
    }
  }, {
    key: "save",
    value: function save(request) {
      return client.mutate({
        mutation: SAVE_USER_MASTER,
        variables: {
          type1: request
        }
      });
    } //   static fetch_by_user_apps(userId) {
    //   return client.query({
    //     query: fetchByUserApps,
    //     variables: { type1: userId }
    //   });
    // }

  }, {
    key: "findByUserId",
    value: function findByUserId(userId) {
      return client.query({
        query: FETCH_USER_NAME,
        variables: {
          type1: userId
        }
      });
    }
  }, {
    key: "getUsersForRoutingRelease",
    value: function getUsersForRoutingRelease(app, dept) {
      return client.query({
        query: GET_BY_USER_APPDEPT,
        variables: {
          type1: app,
          type2: dept
        }
      });
    }
  }, {
    key: "findUsersByPersonaName",
    value: function findUsersByPersonaName(personaName) {
      return client.query({
        query: FETCH_USERS,
        variables: {
          type1: personaName
        }
      });
    }
  }, {
    key: "saveUserPersona",
    value: function saveUserPersona(request) {
      return client.mutate({
        mutation: ADD_USER,
        variables: {
          type: request
        }
      });
    }
  }, {
    key: "removeUserPersona",
    value: function removeUserPersona(userId, personaName) {
      return client.mutate({
        mutation: REMOVE_USER,
        variables: {
          type1: userId,
          type2: personaName
        }
      });
    }
  }, {
    key: "getUser",
    value: function getUser(userId) {
      return client.query({
        query: GET_USER_DEPARTMENTS,
        variables: {
          type1: userId
        }
      }).then(function (_ref3) {
        var data = _ref3.data;
        return data.getUser[0];
      });
    }
  }, {
    key: "getProfileImage",
    value: function getProfileImage(userId) {
      return client.query({
        query: GET_PROFILE_IMAGE,
        variables: {
          type1: userId // type1: "kbhaskar"

        }
      }).then(function (_ref4) {
        var data = _ref4.data;
        return data.getProfileImage;
      });
    }
  }, {
    key: "resetCache",
    value: function resetCache() {
      return client.resetStore();
    }
  }, {
    key: "getUserDepartmentsByApp",
    value: function getUserDepartmentsByApp(userId, appName) {
      return client.query({
        query: GET_USER_DEPARTMENTS_BY_APP,
        variables: {
          type1: userId,
          type2: appName
        }
      });
    }
  }]);

  return EntitlementService;
}();

var _default = EntitlementService;
exports.default = _default;